import { JhTable, JhTableHeader, JhTableRow, JhTableHead, JhTableBody, JhTableCell } from "designPackages/tablePackage";

const TableSkeleton = () => (
    <div id="th-v2-table-skeleton-container" className="overflow-x-auto tw-root">
        <JhTable className="bg-white w-full max-sm:w-[1000px]">
            <JhTableHeader>
                <JhTableRow>
                    <JhTableHead className="w-[35%]">
                        <div id="th-v2-table-skeleton-header-1" className="h-4 w-24 bg-slate-200 rounded animate-pulse" />
                    </JhTableHead>
                    <JhTableHead className="w-[15%]">
                        <div id="th-v2-table-skeleton-header-2" className="h-4 w-16 bg-slate-200 rounded animate-pulse" />
                    </JhTableHead>
                    <JhTableHead className="w-[15%]">
                        <div id="th-v2-table-skeleton-header-3" className="h-4 w-12 bg-slate-200 rounded animate-pulse" />
                    </JhTableHead>
                    <JhTableHead className="w-[15%]">
                        <div id="th-v2-table-skeleton-header-4" className="h-4 w-16 bg-slate-200 rounded animate-pulse" />
                    </JhTableHead>
                    <JhTableHead className="w-[20%] text-right">
                        <div id="th-v2-table-skeleton-header-5" className="h-4 w-20 bg-slate-200 rounded animate-pulse ml-auto" />
                    </JhTableHead>
                </JhTableRow>
            </JhTableHeader>
            <JhTableBody>
                {Array.from({ length: 5 }).map((_, index) => (
                    <JhTableRow key={index}>
                        <JhTableCell>
                            <div id={`th-v2-table-skeleton-row-${index}-cell-1`} className="space-y-2">
                                <div id={`th-v2-table-skeleton-row-${index}-cell-1-line-1`} className="h-4 w-32 bg-slate-200 rounded animate-pulse" />
                                <div id={`th-v2-table-skeleton-row-${index}-cell-1-line-2`} className="h-3 w-24 bg-slate-200 rounded animate-pulse" />
                            </div>
                        </JhTableCell>
                        <JhTableCell>
                            <div id={`th-v2-table-skeleton-row-${index}-cell-2`} className="h-4 w-16 bg-slate-200 rounded animate-pulse" />
                        </JhTableCell>
                        <JhTableCell>
                            <div id={`th-v2-table-skeleton-row-${index}-cell-3`} className="h-6 w-20 bg-slate-200 rounded animate-pulse" />
                        </JhTableCell>
                        <JhTableCell>
                            <div id={`th-v2-table-skeleton-row-${index}-cell-4`} className="h-4 w-20 bg-slate-200 rounded animate-pulse" />
                        </JhTableCell>
                        <JhTableCell className="text-right">
                            <div id={`th-v2-table-skeleton-row-${index}-cell-5`} className="h-4 w-16 bg-slate-200 rounded animate-pulse ml-auto" />
                        </JhTableCell>
                    </JhTableRow>
                ))}
            </JhTableBody>
        </JhTable>
    </div>
);
export default TableSkeleton;